"use client";
import React, { Component } from "react";
import Layout from "../../../container";
import Router from "next/router";
import {
  Divider,
  Grid,
  Icon,
  Label,
  Dimmer,
  Loader,
  Dropdown,
  Button,
  Form,
  GridRow,
  GridColumn,
  TextArea,
  Tab,
  Rating,
  Segment,
  Popup,
  Image,
} from "semantic-ui-react";
import {
  ButtonItem,
  NhGallery,
  Gallery,
  InText,
  LoginModal,
  NhMapContainer,
  Segmant,
  SignupModal,
  Title,
  Wcomment,
  NewWcomment,
  AmenitiesItem,
  TableItem,
  FormError,
} from "../../../components";
import {
  CommentList,
  Description,
  IconsGrid,
  ItemsList,
  NeighborhoodsList,
  NewDescription,
  SimilarcityList,
  EditorDescription,
} from "../../../common";
import {
  cityData,
  commData,
  desData,
  homeData,
  iconData,
  imageData,
  itemData,
  editorData,
  shead,
} from "./data.json";
// import { Amplify } from "aws-amplify";
import { fetchAuthSession, getCurrentUser, signIn } from "aws-amplify/auth";
// import Map from "./map";
import BottomMap from "./bottommap";
import {
  getAllcityreview,
  helpcityreview,
  editorrate,
  getcityscore,
  editcityreview,
  deletecityreview,
} from "../../../modules/Graphql/cityreviewgraphql.js";
import { LandingFooter } from "../../../pagecomponents/Welcome";
import {
  getAllUserList,
  getAgents,
} from "../../../modules/Graphql/usergraphql";
import {
  addquestion,
  getAllquestions,
  getcitydata,
  getsimilarcities,
} from "../../../modules/Graphql/cityquestionandanswergraphql";
import {
  addquestionandreplies,
  helpanswer,
} from "../../../modules/Graphql/cityquestionandrepliesgraphql";
import {
  addsavedcitybyuser,
  checkSavedcitybyuserStatus,
} from "../../../modules/Graphql/savedcitybyusergraphql";
import {
  getcityimages,
  UpdateCityImage,
  DeleteCityImage,
  UpdateCityrate,
  helpcityimagesreview,
} from "../../../modules/Graphql/cityimagesgraphql";
import { getschoolincity } from "../../../modules/Graphql/schoolincitygraphql";
import axios from "axios";
import { sendNotification } from "../../../modules/Graphql/notificationgraphql";
import {
  addNeighbourSearch,
  getNeighborSearch,
  updateNeighborSearch,
} from "../../../modules/Graphql/neighborsearchgraphql";
import Modal from "react-modal";
import CityGallery from "./gallery";
import Head from "next/head";
import CognitoConfig from "../../../common/Cognitoconfig";
// import ReactStars from "react-rating-stars-component";
// Amplify.configure(CognitoConfig);

import Slidersingle from "react-rangeslider";
import Slider from "rc-slider";
import { pricemin, pricemax } from "../../../common/Data/price.json";
import {
  get_converted_value,
  customencodeURIComponent,
  customdecodeURIComponent,
  formattedCityName,
} from "../../../common/Utils";
import { AiOutlineConsoleSql } from "react-icons/ai";
import VictoryMap from "./VictoryMap";
import FeedbackForm from "../../../common/FeedbackForm";
import ShareModal from "./ShareModal";
import AgentContact from "../../../components/AgentContact";
import { createsubscription } from "../../../modules/Graphql/neighborhoodgraphql";
import CitySEO from "./CitySEO";
import CityTitle from "./CityTitle";
import { get_ranking } from "../../Neighborhood/[id]/utils";
import RatingStars from "../../Neighborhood/[id]/RatingStars.js";
import ShareButton from "../../Neighborhood/[id]/ShareButton.js";
import NeighborhoodFactorsSection from "../../Neighborhood/[id]/NeighborhoodFactorsSection.js";
import SchoolsSection from "../../Neighborhood/[id]/SchoolsSection.js";
import SubscribeModal from "../../Neighborhood/[id]/SubscribeModal.js";
import SuccessModal from "../../Neighborhood/[id]/SuccessModal.js";
import EditReviewModal from "../../Neighborhood/[id]/EditReviewModal.js";
import EditCaptionModal from "../../Neighborhood/[id]/EditCaptionModal.js";
import schoolgradesData from "../../Neighborhood/[id]/schoolGrades.js";
import {
  sortbyoptions,
  sortbyeditoroptions,
} from "../../Neighborhood/[id]/SortByOptions.js";
import {
  customStyles,
  customStylesReview,
  customStylesSlide,
} from "../../Neighborhood/[id]/modalStyles";
import SaveCityButton from "./SaveCityButton";
import FollowCityPopup from "./FollowCityPopup";

var humanFormat = require("human-format");

class DetailsCity extends Component {
  city_name;
  state_name;
  nhids = [];
  schoolgrades = schoolgradesData;

  constructor(props) {
    super(props);
    const hasInitialData = props.initialData && props.initialData.data;
    this.primary_polygon_points = [];

    this.myRef = React.createRef();
    this.state = {
      display: true,
      reply: {},
      ques: false,
      comment: {},
      loggedin: false,
      save: false,
      data: {},
      activePage: 1,
      activePage1: 1,
      activePage2: 1,
      id: "",
      onquestion: "",
      onreply: "",
      oncomment: "",
      smodal: false,
      lmodal: false,
      heart: {},
      like: {},
      rlike: {},
      qlike: {},
      staticData: {
        name: "San Carlos, CA",
        npi: "NPI: 901 (#10 in the area)",
        vi: "Value Index: 1.15 (Great Value)",
      },
      replies: {},
      commentData: commData,
      userdetails: "",
      email_err_status: false,
      email_err_msg: "",
      pwd_err_status: false,
      pwd_err_msg: "",
      revs: false,
      askque: false,
      desData: [],
      sortby: "createDate",
      Cityreviews: hasInitialData?.getcityreview
        ? hasInitialData?.getcityreview
        : [],
      userId: "",
      returnemail: "",
      userimage: "",
      realestatefirm: "",
      questions: [],
      showeditbutton: false,
      cityscores: hasInitialData?.getcityscore
        ? hasInitialData?.getcityscore
        : [],
      factors: [],
      factors_right: [],
      loading: false,
      city: this.props.city_name,
      rhpmapcords: [],
      lat: "",
      lng: "",
      values: [],
      topneighborhood: hasInitialData?.getcitydata
        ? hasInitialData?.getcitydata
        : [],
      cityimages: hasInitialData?.getcityimage
        ? hasInitialData?.getcityimage
        : [],
      is_slider: false,
      is_static: false,
      modalSlider: false,
      selectedItem: 0,
      is_editor: false,
      editcaptionmodal: false,
      selectedcaption: "",
      selectedcaptionID: "",
      similarcities: [],
      loaderactive: false,
      houseberrycount: 0,
      allcount: 0,
      pendingcount: 0,
      houseberrypickreview: [],
      pendingreview: [],
      is_display_review_txt: false,
      is_change_review_txt: false,
      citypersonalscore: 0,
      optionsmin: pricemin,
      selectedmin: "0",
      selectedmax: "0",
      optionsmax: pricemax,
      pricemax: "0",
      pricemin: "0",
      schoolval: 0,
      crimerateval: 0,
      walkabilityval: 0,
      townval: 0,
      curbappealval: 0,
      communityval: 0,
      valueval: 0,
      is_from_add: false,
      initial_pre_data: [],
      npirank: "",
      county_name: "",
      cityrank: "",
      state_name: "",
      is_from_save: false,
      is_from_city_review: false,
      amenities_factor: [],
      amenitiesscore: 0,
      amenitiesFlag: false,
      islistingmodalopen: false,
      agent_data: [],
      isratemodalopen: false,
      keyworddata: [],
      houseberrytakereview: [],
      modaleditreviewIsopen: false,
      editreviewdata: "",
      valueclub: 0,
      publicrate_err: false,
      valuequality: 0,
      curbrate_err: false,
      keywordfirst: "",
      keywordsec: "",
      keywordthird: "",
      description_err_status: false,
      description_err_msg: "",
      isMobile: false,
      schoolloader: false,
      schoolloadertxt: "Loading...",
      ismodalopen: false,
      subscribemodal: false,
      subscribeemail: "",
      subscribeemailstatus: false,
      subscribe_err_msg: "",
      clickedItem: "",
      subscribe_success_msg: "",
      isShareModalOpen: false,
      showAgentPopup: false,
    };
    this.initial_result = [];
    this.schoollisting = [];
    this.onReplySubmit = this.onReplySubmit.bind(this);
    this.getcityscore = this.getcityscore.bind(this);
    this.checkSavedStatus = this.checkSavedStatus.bind(this);
    this.getcityReviews = this.getcityReviews.bind(this);
    this.onSaveCity = this.onSaveCity.bind(this);
    this.getquestionandanswers = this.getquestionandanswers.bind(this);
    this.askreply = this.askreply.bind(this);
    this.getplolygon = this.getplolygon.bind(this);
    this.onImage = this.onImage.bind(this);
    this.openpopup = this.openpopup.bind(this);
    this.removephoto = this.removephoto.bind(this);
    this.closeeditcaptionmodal = this.closeeditcaptionmodal.bind(this);
    this.EditcaptionFormSubmit = this.EditcaptionFormSubmit.bind(this);
    this.onRatemodal = this.onRatemodal.bind(this);
    this.editphotocaption = this.editphotocaption.bind(this);
    this.closeModalpersonal = this.closeModalpersonal.bind(this);
    this.openpersonalmodal = this.openpersonalmodal.bind(this);
    this.handlecloseisratemodal = this.handlecloseisratemodal.bind(this);
    this.openeditreviewmodal = this.openeditreviewmodal.bind(this);
    this.closeeditreviewmodal = this.closeeditreviewmodal.bind(this);
    this.closesubscribemodal = this.closesubscribemodal.bind(this);
    this.EditreviewFormSubmit = this.EditreviewFormSubmit.bind(this);
  }
  closesubscribemodal = () => {
    this.setState({ subscribemodal: false });
  };
  handlecloseisratemodal = () => {
    this.setState({ isratemodalopen: false });
  };
  handleWindowSizeChange = () => {
    this.setState({ isMobile: window.innerWidth <= 767 });
  };

  EditreviewFormSubmit(e) {
    const reviewData = [...this.state.houseberrytakereview];
    const reviewTxt = this.state.editreviewdata;
    var flag = 1;

    var description_length = reviewTxt.length;
    if (this.state.valueclub === 0) {
      flag = 0;
      this.setState({ publicrate_err: true });
    }
    if (this.state.valuequality === 0) {
      flag = 0;
      this.setState({ curbrate_err: true });
    }
    if (reviewTxt === "") {
      flag = 0;
      this.setState({
        description_err_status: true,
        description_err_msg:
          "Please enter your review (Maximum 5000 characters are required).",
      });
    }

    if (reviewTxt && reviewTxt.length > 4998) {
      flag = 0;
      this.setState({
        description_err_status: true,
        description_err_msg:
          "You enter " +
          description_length +
          " Characters Maximum 5000 characters are allowed.",
      });
    }
    if (flag === 1) {
      let keywords;
      if (
        this.state.keywordfirst ||
        this.state.keywordsec ||
        this.state.keywordthird
      ) {
        keywords =
          this.state.keywordfirst +
          "," +
          this.state.keywordsec +
          "," +
          this.state.keywordthird;
      } else {
        keywords = "";
      }
      var adddata = {
        description: customencodeURIComponent(reviewTxt),
        reviewId: reviewData[0].id,
        neighborhoodId: this.state.topneighborhood[0].postalcity_name,
        keywords: keywords,
        publicSpacesRating: this.state.valueclub || 0,
        curbAppealRating: this.state.valuequality || 0,
      };
      editcityreview(adddata)
        .then((result) => {
          this.getcityReviews(this.state.sortby);
          this.getcitydata();
          this.setState({ modaleditreviewIsopen: false });
        })
        .catch((error) => {});
    }
  }

  reviewChange = (e) => {
    this.setState({ editreviewdata: e.target.value });
  };

  openpopup = (e, length) => {
    this.setState({ modalSlider: true });
    this.setState({ selectedItem: e });
    setTimeout(() => {
      this.setState({ islistingmodalopen: true });
    }, "500");
  };

  closeeditcaptionmodal() {
    this.setState({ editcaptionmodal: false });
  }

  EditcaptionFormSubmit(e) {
    const caption_data = e.target.caption_summary.value;
    this.setState({ is_slider: false });
    const updatedata = {
      caption: caption_data,
      id: this.state.selectedcaptionID,
    };

    UpdateCityImage(updatedata)
      .then((result) => {
        this.setState({ editcaptionmodal: false });
        this.setState({ is_slider: true });
        this.getcityimage();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  onRatemodal(imageid, e) {
    this.setState({ is_slider: false });
    const updatedata = {
      rate: e.target.textContent,
      id: imageid,
    };
    UpdateCityrate(updatedata)
      .then((result) => {
        this.setState({ is_slider: true });
        // this.setState({editcaptionmodal: false});

        this.getcityimage();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  closeModalsucess = () => {
    this.setState({ ismodalopen: false });
  };

  removephoto = (e, id) => {
    const deletedataId = {
      id: id,
    };
    this.setState({ is_slider: false });
    DeleteCityImage(deletedataId)
      .then((result) => {
        //this.setState({is_slider:true});
        let initial_data = this.initial_result[0];
        for (var i = 0; i < initial_data.length; i++) {
          if (initial_data[i].id == id) {
            initial_data.splice(i, 1);
          }
        }
        if (initial_data.length > 0) {
          this.getcityimage();
        } else {
          this.setState({ nhimagesdata: initial_data });
        }

        // this.getNhDetails();
      })
      .catch((error) => {
        console.log("error->", error);
      });
  };

  editphotocaption = (e, id, caption) => {
    this.setState({ editcaptionmodal: true });
    this.setState({ selectedcaption: caption });
    this.setState({ selectedcaptionID: id });
  };

  getagents() {
    let neighborhoodIds = this.nhids.join("','");
    const getdata = {
      start: 0,
      limit: 10,
      orderBy: "'" + neighborhoodIds + "'",
      order: "DESC",
      fields: [
        {
          name: "neighborhoodid",
          value: "",
          operator: "!=",
        },
      ],
    };
    getAgents(getdata)
      .then((result) => {
        let agentitems = [];
        result.data.getAgents &&
          result.data.getAgents.length > 0 &&
          result.data.getAgents.map((item, index) => {
            agentitems.push({
              id: item.id,
              size: "tiny",
              image: item.userimage
                ? item.userimage
                : process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/userdefault.png",
              head: item.firstName + " " + item.lastName,
              subhead: item.realEstateFirm,
              extra: item.points + " Points",
            });
          });

        this.setState({ agent_data: agentitems });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeModalslider = () => {
    this.setState({ modalSlider: false });
    this.setState({ islistingmodalopen: false });
  };

  getLastSegment = (url) => {
    return url.replace(/\/$/, "").split("/").pop();
  };

  onSubscribebtnClick = (clickedItem) => {
    this.setState({
      subscribeemail: "",
      subscribeemailstatus: false,
      subscribe_err_msg: "",
      clickedItem: clickedItem,
      subscribe_success_msg: "",
    });
    this.setState({ subscribemodal: !this.state.subscribemodal });
  };

  handleShareButtonClick = () => {
    this.setState({ isShareModalOpen: true });
  };

  handleCloseShareModal = () => {
    this.setState({ isShareModalOpen: false });
  };

  componentDidMount() {
    const isfromreview = localStorage.getItem("isfromCityreview");
    if (isfromreview === "Yes") {
      this.setState({ ismodalopen: true });
      localStorage.removeItem("isfromCityreview");
    }
    const dynamicUrl = window.location.href;
    // const slug = this.getLastSegment(dynamicUrl);
    localStorage.setItem("city_fullName", slug);

    const cityFullName = localStorage.getItem("city_fullName");

    this.setState({ cityFullName });
    this.handleWindowSizeChange();
    const slug = this.props.nhname;
    this.handleWindowSizeChange();
    // Check if we have pre-loaded data from props (SSG data)
    if (this.props.initialData) {
      // Use the pre-loaded data immediately - this is from SSG
      // this.setState({ loading: false });
      this.fetchInitialData(this.props.initialData);
    } else if (slug) {
      axios
        .get(`../../../static/citydata/${slug}.json`)
        .then((response) => {
          // Store the fetched data in the class variable
          let result = response.data.result;
          this.fetchInitialData(result);
        })
        .catch((error) => {
          console.error("Error fetching JSON:", error.message);
        });
    }
    this.fetchOriginalData();
  }
  fetchInitialData(result) {
    this.handleWindowSizeChange();
    window.addEventListener("resize", this.handleWindowSizeChange);
    let data = JSON.stringify(commData);
    const dynamicUrl = window.location.href;
    const slug = this.getLastSegment(dynamicUrl);

    // const searchParams = new URLSearchParams(window.location.search);
    this.city_name = slug;
    this.setState({ topneighborhood: result.data.getcitydata }, () => {
      this.setCitydata(result);
      this.setCityImages(result);
      this.setCityQuetions(result);
      this.setCityReview(result);
      this.setCityScore(result);
    });
  }
  fetchOriginalData() {
    const dynamicUrl = window.location.href;
    const slug = this.getLastSegment(dynamicUrl);

    // const searchParams = new URLSearchParams(window.location.search);

    this.city_name = slug;

    this.getcitydata();
    let data = JSON.stringify(commData);
    if (localStorage.commData === undefined || localStorage.commData === null) {
      localStorage.setItem("commData", data);
    } else {
      let prevCommData = JSON.parse(localStorage.getItem("commData"));
      this.setState({
        commentData: prevCommData,
      });
    }
    getCurrentUser()
      .then(async () => {
        const session = await fetchAuthSession();
        const userAttributes = session.tokens?.idToken?.payload;
        // Map the attributes to match the old structure
        const userdetails = userAttributes
          ? [
              userAttributes["custom:usertype"] || "",
              userAttributes.sub || "",
              userAttributes.email_verified === "true" || false,
              userAttributes["custom:firstname"] || "",
              userAttributes["custom:id"] || "",
              userAttributes["custom:lastname"] || "",
              userAttributes["custom:confirmpassword"] || "",
              userAttributes.email || "",
            ]
          : [];

        if (userdetails[2] === true) {
          this.setState({
            userdetails: userdetails,
            loggedin: true,
            returnemail: userdetails[7],
          });
        }
        if (localStorage.saveN) {
          this.setState({
            save: true,
          });
        }
        if (editorData.includes(userdetails[7])) {
          this.setState({ showeditbutton: !this.state.showeditbutton });

          const sortby = "editor_rate";
          this.getcityReviews(sortby);
          this.setState({ sortby: "editor_rate" });
          this.setState({ is_editor: true });
        } else {
          this.getcityReviews(this.state.sortby);
        }
        const getdata = {
          start: 0,
          limit: 10,
          orderBy: "email",
          order: "ASC",
          fields: [
            { name: "email", value: this.state.returnemail, operator: "=" },
          ],
        };
        getAllUserList(getdata)
          .then((result) => {
            // this.setState({userId: result.data.getUser2[0].id})
            if (result.data.getUser && result.data.getUser.length > 0) {
              this.setState({ user_info: result.data.getUser });
              this.state.user_info && this.state.user_info.length > 0
                ? this.state.user_info.map((item, index) => {
                    localStorage.setItem("userId", item.id);
                    this.setState({ userId: item.id });
                    this.setState({ userimage: item.userimage });
                    this.setState({ realestatefirm: item.realEstateFirm });
                    // this.setState({realestatelecenceno: item.license})
                  })
                : this.setState({
                    userId: result.data.getUser[0].id,
                  });
              localStorage.setItem("userId", result.data.getUser[0].id);
              this.checkSavedStatus();
              this.getInitialprechange();
              this.getcityscore();

              if (
                localStorage.getItem("savecityid") &&
                localStorage.getItem("savecityid") !== "" &&
                localStorage.getItem("savecityid") !== undefined
              ) {
                if (this.city_name === localStorage.getItem("savecityid")) {
                  this.savecity();
                  this.setState({ save: true });
                  localStorage.removeItem("savecityid");
                }
              }
            } else {
              localStorage.setItem("userId", 0);
            }
          })
          .catch((error) => {
            this.getcityscore();
            this.getInitialprechange();
            console.error(error);
            localStorage.removeItem("userId");
          });
      })
      .catch((err) => {
        this.getcityReviews(this.state.sortby);
        this.getInitialprechange();
        this.getcityscore();
        if (err) {
          this.setState({
            loggedin: false,
            save: false,
          });
        }
        // window.location.href = '/login'
      });
  }
  handlesubscribeemailChange = (e) => {
    this.setState({
      subscribeemail: e.target.value,
      subscribeemailstatus: false,
      subscribe_err_msg: "",
      subscribe_success_msg: "",
    });
  };

  handleChangeclub = (valueclub) => {
    if (valueclub > 0) {
      this.setState({
        publicrate_err: false,
      });
    } else {
      this.setState({
        publicrate_err: true,
      });
    }
    this.setState({ valueclub });
  };
  handleChangequality = (valuequality) => {
    if (valuequality > 0) {
      this.setState({
        curbrate_err: false,
      });
    } else {
      this.setState({
        curbrate_err: true,
      });
    }
    this.setState({ valuequality });
  };

  handlekeywordfirstChange = (e) => {
    this.setState({ keywordfirst: e.target.value });
  };
  handlekeywordsecChange = (e) => {
    this.setState({ keywordsec: e.target.value });
  };
  handlekeywordthirdChange = (e) => {
    this.setState({ keywordthird: e.target.value });
  };

  getInitialprechange = () => {
    if (this.state.userId) {
      const getdatanew = {
        start: 0,
        limit: 1,
        orderBy: this.state.userId,
        order: "ASC",
        fields: [
          {
            name: "userId",
            value: this.state.userId,
            operator: "=",
          },
        ],
      };

      getNeighborSearch(getdatanew)
        .then((result) => {
          this.setState({ initial_pre_data: result.data.getneighborsearch });
          result.data.getneighborsearch &&
            result.data.getneighborsearch.length > 0 &&
            result.data.getneighborsearch.map((item, index) => {
              const per_data = {
                userId: this.state.userId,
                schoolScore: item.schoolScore,
                crimeRate: item.crimeRate,
                walkability: item.walkability,
                towncenter: item.towncenter,
                curbAppeal: item.curbAppeal,
                publicspaces: item.publicspaces,
                valueIndex: item.valueIndex,
                pricemax: item.pricemax.toString(),
                pricemin: item.pricemin.toString(),
              };
              localStorage.setItem("personal_data", JSON.stringify(per_data));
              this.setState({
                schoolval: item.schoolScore,
                townval: item.towncenter,
                crimerateval: item.crimeRate,
                walkabilityval: item.walkability,
                communityval: item.publicspaces,
                curbappealval: item.curbAppeal,
                valueval: item.valueIndex,
                pricemax: item.pricemin.toString(),
                pricemin: item.pricemax.toString(),
                //mindisplay:true,
                //redirectval:prevData.findval
              });
            });
          if (
            result.data.getneighborsearch &&
            result.data.getneighborsearch.length === 0
          ) {
            if (
              localStorage.getItem("personal_data") &&
              localStorage.getItem("personal_data") !== ""
            ) {
              const local_personaldata = JSON.parse(
                localStorage.getItem("personal_data"),
              );

              this.setState({
                schoolval: local_personaldata.schoolScore,
                townval: local_personaldata.towncenter,
                crimerateval: local_personaldata.crimeRate,
                walkabilityval: local_personaldata.walkability,
                communityval: local_personaldata.publicspaces,
                curbappealval: local_personaldata.curbAppeal,
                valueval: local_personaldata.valueIndex,
                pricemax: local_personaldata.pricemax.toString(),
                pricemin: local_personaldata.pricemin.toString(),
                //mindisplay:true,
                //redirectval:prevData.findval
              });
            }

            //localStorage.setItem("personal_data", JSON.stringify(per_data));
          }
          if (
            localStorage.getItem("is_from_save") &&
            localStorage.getItem("is_from_save") !== "" &&
            localStorage.getItem("is_from_save") !== undefined
          ) {
            if (localStorage.getItem("is_from_save") === "Y") {
              this.addpersonaldata();
            }
            localStorage.setItem("is_from_save", "");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const local_personaldata = JSON.parse(
        localStorage.getItem("personal_data"),
      );

      if (
        local_personaldata &&
        local_personaldata !== undefined &&
        local_personaldata !== ""
      ) {
        this.setState({
          schoolval: local_personaldata.schoolScore,
          townval: local_personaldata.towncenter,
          crimerateval: local_personaldata.crimeRate,
          walkabilityval: local_personaldata.walkability,
          communityval: local_personaldata.publicspaces,
          curbappealval: local_personaldata.curbAppeal,
          valueval: local_personaldata.valueIndex,
          pricemax: local_personaldata.pricemax,
          pricemin: local_personaldata.pricemin,
          //mindisplay:true,
          //redirectval:prevData.findval
        });
      }
      // localStorage.setItem("personal_data", JSON.stringify(per_data));
    }
  };
  openAgentPopup = () => {
    this.setState({ showAgentPopup: true });
  };

  closeAgentPopup = () => {
    this.setState({ showAgentPopup: false });
  };

  getplolygon = (citydata, statedata) => {
    const google = window.google;

    if (google && google != undefined) {
      var geocoder = new google.maps.Geocoder();
      let final_cords = [];
      let that = this;
      var city_name = citydata + ", " + statedata;
      if (geocoder) {
        geocoder.geocode({ address: city_name }, function (results, status) {
          let searchaddress = city_name
            ? city_name.replace(/,[^,]+$/, "%")
            : "";

          if (
            results &&
            (results[0].types[0] === "locality" ||
              results[0].types[0] === "neighborhood")
          ) {
            var citydata = [];
            axios
              .get(
                `https://nominatim.openstreetmap.org/search?q=${city_name}&polygon_geojson=1&format=geojson`,
              )
              .then((res) => {
                if (res.data && res.data.features.length > 0) {
                  var result = res.data.features.filter(
                    (number) =>
                      number.geometry.type === "Polygon" ||
                      number.geometry.type === "MultiPolygon" ||
                      number.geometry.type === "FeatureCollection",
                  );
                  result = result[0];

                  var city_info = res.data;
                  const latitude = (result.bbox[1] + result.bbox[3]) / 2;
                  const longitude = (result.bbox[0] + result.bbox[2]) / 2;

                  that.setState({
                    lat: latitude,
                  });
                  that.setState({
                    lng: longitude,
                  });

                  // that.getSimilarCity(latitude, longitude);
                  var id = 0;
                  if (
                    searchaddress === "Hillsborough, CA%" ||
                    searchaddress === "Hillsborough CA%" ||
                    searchaddress === "Hillsborough, California%" ||
                    searchaddress === "San Mateo%" ||
                    searchaddress === "San Mateo" ||
                    searchaddress === "Alameda, CA%" ||
                    searchaddress === "San Mateo CA%" ||
                    searchaddress === "San Mateo, CA%" ||
                    searchaddress === "San Mateo, California%" ||
                    searchaddress === "Hillsborough" ||
                    searchaddress === "Hillsborough CA"
                  ) {
                    id = 1;
                  } else {
                    if (result.geometry.type === "Point") {
                      id = 1;
                    }
                  }
                  if (result.geometry.type === "Polygon") {
                    citydata = result.geometry.coordinates[0];
                  } else if (result.geometry.type === "MultiPolygon") {
                    var c_length = result.geometry.coordinates.length;
                    citydata = result.geometry.coordinates[0][0];
                  }
                  window.y = result;
                  if (result.geometry.type === "MultiPolygon") {
                    var cities_length = result.geometry.coordinates.length;

                    var multi_city = [];
                    for (var i = 0; i < cities_length; i++) {
                      multi_city.push(
                        result.geometry.coordinates[i][0].map((item, index) => {
                          return {
                            lat: parseFloat(item[1]),
                            lng: parseFloat(item[0]),
                          };
                        }),
                      );
                    }
                    that.setState({ rhpmapcords: multi_city[0] });
                  } else {
                    let city_reservdedata = citydata.map((item5, index5) => {
                      return {
                        lat: parseFloat(item5[1]),
                        lng: parseFloat(item5[0]),
                      };
                    });
                    that.setState({ rhpmapcords: city_reservdedata });
                    // this.bermudaTriangle3 = new google.maps.Polygon({
                    //   paths: [city_reservdedata],
                    //   strokeWeight: 3.6,
                    //   strokeColor: 'green',
                    //   fillOpacity: 0,
                    //   zIndex: 0,
                    //   name: city_info.features[0].properties.display_name
                    // })
                  }
                }
              });
          }
        });
      }
    } else {
      window.location.reload();
    }
  };
  getschoolincity = () => {
    this.setState({ schoolloader: true });
    let city = this.state.topneighborhood[0].postalcity_name;
    var getdata = {
      cityname: city,
    };
    getschoolincity(getdata)
      .then((result) => {
        let arr = [];

        result.data.getschoolincity.map((item, index) => {
          if (item.GreatSchoolsRating != "") {
            let schooltypes = "";
            if (this.schoolgrades.primaryarr.includes(item.GSserved)) {
              schooltypes = "Primary";
            } else if (this.schoolgrades.middlearr.includes(item.GSserved)) {
              schooltypes = "Middle";
            } else if (this.schoolgrades.higharr.includes(item.GSserved)) {
              schooltypes = "High";
            }

            arr.push({
              school: item.School,
              type: schooltypes,
              grades: item.GSserved,
              // rating: item.GreatSchoolsRating,
              schoolurl: item.greatschoolurl,
              testscorerating: item.TestScores
                ? Number(((item.TestScores / 10) * 5).toFixed(2)).toFixed(1)
                : "",
            });
          }
        });
        let data = arr.sort((a, b) => {
          if (a.type > b.type) return -1;
          if (a.type < b.type) return 1;
          return 0;
        });
        this.schoollisting = data;
        this.setState({ schoolloader: false, schoolloadertxt: "" });
        this.forceUpdate();

        this.schoollisting = data;
      })
      .catch((error) => {});
  };
  getcitydata = () => {
    let cityname = this.city_name ? this.city_name : "";
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "npi",
      fields: [{ name: "cityfullname", value: cityname, operator: "=" }],
    };
    getcitydata(getdata)
      .then((result) => {
        this.setCitydata(result);
      })
      .catch((error) => {
        console.log("error-->", error);
      });
  };

  setCitydata = (result) => {
    let cdata = [];
    if (result.data.getcitydata && result.data.getcitydata.length > 0) {
      this.setState({ topneighborhood: result.data.getcitydata }, () => {
        this.getcityrank(
          result.data.getcitydata[0].county_name,
          result.data.getcitydata[0].postalcity_name,
        );
        this.getquestionandanswers();
        this.getschoolincity();
        this.getcityimage();
        this.getplolygon(
          result.data.getcitydata[0].postalcity_name,
          result.data.getcitydata[0].label.split(",").pop(),
        );
      });

      this.setState({
        county_name: result.data.getcitydata[0].county_name,
        state_name: result.data.getcitydata[0].label.split(",").pop(),
      });

      result.data.getcitydata.map((item, index) => {
        if (item.id) {
          this.nhids.push(item.id);
        }
        if (item.geometry_cords) {
          cdata.push(item.geometry_cords);
        }
      });

      this.getagents();
      // cdata.map((item3, index3) => {
      //   item3.map((item4, index4) => {
      //     if (!this.primary_polygon_points.includes(item4)) {
      //       this.primary_polygon_points.push(item4);
      //     }
      //   });
      // });
    }
  };

  getcityimage = () => {
    let cityname = this.state.topneighborhood[0].postalcity_name;
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "id",
      fields: [{ name: "cityname", value: cityname, operator: "=" }],
    };
    getcityimages(getdata)
      .then((result) => {
        this.setCityImages(result);
      })
      .catch((error) => {
        console.log("error-->", error);
      });
  };
  setCityImages = (result) => {
    this.setState({ cityimages: result.data.getcityimage });
    if (result.data.getcityimage && result.data.getcityimage.length > 0) {
      if (this.state.is_slider === true) {
        this.setState({ is_static: false });
        let previous_arr = this.initial_result[0];
        let new_fetch_data = result.data.getcityimage;
        let final_arr = [];
        previous_arr.map(function (x) {
          var result = new_fetch_data.filter((a1) => a1.id == x.id);
          if (result.length > 0) {
            x.imagehelpfulcount = result[0].imagehelpfulcount;
            x.caption = result[0].caption;
            x.rate = result[0].rate;
          }
          //return x
          final_arr.push(x);
        });
        this.setState({ cityimages: final_arr });
      } else {
        this.initial_result.push(result.data.getcityimage);
        this.setState({ cityimages: result.data.getcityimage });
      }
    } else {
      this.setState({ is_static: true });
      this.setState({ cityimages: imageData });
    }
  };
  getcityrank = (county_name, postalcity_name) => {
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "npiscore_city",
      fields: [
        { name: "county_name", value: county_name, operator: "=" },
        { name: "postalcity_name", value: "", operator: "!=" },
      ],
    };
    getcitydata(getdata)
      .then((result) => {
        let finaldata = result.data.getcitydata;
        let indexdata =
          finaldata &&
          finaldata.length > 0 &&
          finaldata.findIndex(
            (itemData) => itemData.postalcity_name === postalcity_name,
          );
        this.setState({ cityrank: indexdata + 1 });
      })

      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };
  handlescoreclick = (data) => {
    if (data.link === "school") {
      document.getElementById("school_serve").scrollIntoView();
    }
    if (data.link === "amenities") {
      document.getElementById("amenities_nh").scrollIntoView();
    }
  };
  getcityscore = () => {
    this.setState({
      loading: false,
    });
    let cityname = this.city_name ? this.city_name : "";
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "id",
      fields: [{ name: "cityfullname", value: cityname, operator: "=" }],
    };
    getcityscore(getdata)
      .then((result) => {
        this.setCityScore(result);
      })
      .catch((error) => {
        console.log("error-->", error);
      });
  };

  setCityScore = (result) => {
    if (result && result.data.getcityscore.length > 0) {
      this.setState(
        {
          cityscores: result.data.getcityscore,
          loading: false,
        },
        () => {
          let cityname = this.city_name ? this.city_name : "";
          let amenities_factor = [];
          let schoollink = "";
          let amenitieslink = "";
          let schoolscore = this.state.cityscores[0].schoolscore;
          let publicscore = 0;
          let townctrscore = 0;
          let curbappealscore = 0;
          if (schoolscore > 0) {
            schoollink = "school";
          }
          if (
            this.state.cityscores[0].walkscore &&
            this.state.cityscores[0].walkscore != null
          ) {
            townctrscore = Number(
              (this.state.cityscores[0].walkscore / 2).toFixed(1),
            );
          }
          if (
            this.state.cityscores[0].comscore &&
            this.state.cityscores[0].comscore != null
          ) {
            publicscore = Number(this.state.cityscores[0].comscore.toFixed(1));
          }
          if (
            this.state.cityscores[0].crubscore &&
            this.state.cityscores[0].crubscore != null
          ) {
            curbappealscore = Number(
              this.state.cityscores[0].crubscore.toFixed(1),
            );
          }

          let dividedval = 0;
          let totalval = 0;
          if (townctrscore > 0) {
            // this.setState({ amenitiesFlag: false });
            dividedval = dividedval + 1;
            townctrscore = townctrscore;
            totalval = totalval + townctrscore;
          } else {
            this.setState({ amenitiesFlag: true });
            townctrscore = "-";
          }
          if (publicscore > 0) {
            // this.setState({ amenitiesFlag: false });
            dividedval = dividedval + 1;
            publicscore = publicscore;
            totalval = totalval + publicscore;
          } else {
            this.setState({ amenitiesFlag: true });
            publicscore = "-";
          }
          if (curbappealscore > 0) {
            //  this.setState({ amenitiesFlag: false });
            curbappealscore = curbappealscore;
            dividedval = dividedval + 1;
            totalval = totalval + curbappealscore;
          } else {
            this.setState({ amenitiesFlag: true });
            curbappealscore = "-";
          }

          let valuedata = 0;
          let valuescore = 0;
          valuescore = parseInt(this.state.cityscores[0].valuescore);

          if (valuescore) {
            //valuescore = this.state.nhdetails[0].value;
            valuescore =
              "$" +
              humanFormat(this.state.cityscores[0].valuescore).replace(
                /\s/g,
                "",
              );
            valuescore = valuescore.replace(/-?\d+(\.\d+)?/g, (n) =>
              Number(n).toFixed(0),
            );
            valuescore = valuescore.replace("-", "");
            valuedata = parseInt(this.state.cityscores[0].valuescore);
            //valuescore = Number(((valuescore / 100) * 5).toFixed(2)).toFixed(1);
          } else {
            valuescore = "-";
            valuedata = "-";
          }
          if (
            townctrscore === "-" &&
            publicscore === "-" &&
            curbappealscore === "-"
          ) {
            this.setState({ amenitiesFlag: false });
          }

          let amenitiesscore = parseFloat(totalval / dividedval);
          amenitiesscore = Number(amenitiesscore.toFixed(1));

          if (amenitiesscore > 0 || amenitiesscore !== "-") {
            amenitieslink = "amenities";
          }
          if (amenitiesscore > 0) {
            amenitiesscore = amenitiesscore;
            this.setState({ amenitiesscore: amenitiesscore });
          } else {
            if (townctrscore > 0) {
              amenitiesscore = townctrscore;
            } else {
              amenitiesscore = "-";
            }
            this.setState({ amenitiesscore: amenitiesscore });
          }

          amenities_factor.push(
            {
              icon:
                process.env.NEXT_PUBLIC_CDN_ID + "static/images/merchant.png",
              title: "Near good merchants",
              score: townctrscore,
            },
            {
              icon:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/public_space.png",
              title: "Public Spaces",
              score: publicscore,
            },
            {
              icon:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/curb_appeal.png",
              title: "Curb Appeal",
              score: curbappealscore,
            },
          );
          let factors = [];
          let factors_right = [];

          for (var i = 0; i < 1; i++) {
            factors.push(
              {
                HeaderImage:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/factors/school-grey.svg",
                SubContent: Number(
                  ((this.state.cityscores[0].schoolscore / 10) * 5).toFixed(2),
                ).toFixed(1),
                tooltiptext: "Neighborhood Weighted Average School Score",
                medianPriceDomCityFlag: false,
                appreciationCityFlag: false,
                link: schoollink,
                title: "School",
                amenitiesFlag: false,
                txtColor: "rgb(15, 20, 67)",
              },
              {
                HeaderImage:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/factors/safety-grey.svg",
                SubContent: Number(
                  ((this.state.cityscores[0].crimescore / 10) * 5).toFixed(2),
                ).toFixed(1),
                tooltiptext:
                  "Neighborhood Safety Score Ratings from <a href='/' title='Crimeometer'>Crimeometer</a> and Ratings from <a href='#' title='NeighborhoodScout'>NeighborhoodScout</a>",
                medianPriceDomCityFlag: false,
                appreciationCityFlag: false,
                link: "safety",
                title: "Safety",
                amenitiesFlag: false,
                txtColor: "rgb(15, 20, 67)",
              },
              {
                HeaderImage:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/factors/amenities-grey.svg",
                SubContent: this.state.amenitiesscore,
                tooltiptext:
                  "Proximity to Merchants Access to Public Spaces Neighborhood Curb Appeal Date from <a href='/' title='Walkscore'>Walkscore</a> and user reviews",
                medianPriceDomCityFlag: false,
                appreciationCityFlag: false,
                link: amenitieslink,
                title: "Amenities",
                amenitiesFlag: this.state.amenitiesFlag,
                txtColor: "rgb(15, 20, 67)",
              },
            );
            factors_right.push(
              {
                HeaderImage:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/factors/price-grey.svg",
                SubContent:
                  this.state.cityscores[0].medianpricescore &&
                  (this.state.cityscores[0].medianpricescore > 0 ||
                    this.state.cityscores[0].medianpricescore !== null)
                    ? "$" +
                      humanFormat(
                        this.state.cityscores[0].medianpricescore,
                      ).replace(/\s/g, "")
                    : "-",
                tooltiptext: "Neighbrohood weighted median price",
                medianPriceDomCityFlag: false,
                appreciationCityFlag: false,
                link: "",
                title: "Price",
                amenitiesFlag: false,
                txtColor: "rgb(15, 20, 67)",
              },
              {
                HeaderImage:
                  valuedata === "-"
                    ? process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/factors/undervalued-grey.svg"
                    : valuedata > 0
                      ? process.env.NEXT_PUBLIC_CDN_ID +
                        "static/images/factors/undervalued-grey.svg"
                      : process.env.NEXT_PUBLIC_CDN_ID +
                        "static/images/factors/undervalued-grey.svg",
                SubContent: valuescore,
                tooltiptext:
                  "Neighborhood Value based on neighborhood factors and price",
                appreciationCityFlag: false,
                medianPriceDomCityFlag: false,
                amenitiesFlag: false,
                link: "",
                title:
                  valuedata != "" && valuedata != "-"
                    ? valuedata > 0
                      ? "Overvalued"
                      : "Undervalued"
                    : "Value",
                isUndervalue: valuedata,
                txtColor:
                  valuedata && valuedata != "-" && valuedata > 0
                    ? "#c02e26"
                    : "#238528",
              },
              {
                HeaderImage:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/factors/appreciation-grey.svg",
                SubContent:
                  this.state.cityscores[0].appreciation !== 0
                    ? Math.round(this.state.cityscores[0].appreciation) + "%"
                    : "-",
                tooltiptext: "Neighborhood weighted Appreciation",
                medianPriceDomCityFlag: false,
                appreciationCityFlag: false,
                link: "",
                amenitiesFlag: false,
                title: "Appreciation",
                txtColor:
                  this.state.cityscores[0].appreciation !== "-" &&
                  this.state.cityscores[0].appreciation > 0
                    ? "#238528"
                    : "#c02e26",
              },
            );
          }

          this.setState({
            factors: factors,
            factors_right: factors_right,
            amenities_factor: amenities_factor,
          });
        },
      );
    }
  };
  getSimilarCity = (latitude, longitude) => {
    let cityname = this.city_name
      ? this.state.topneighborhood[0].postalcity_name
      : "";
    if (
      this.state.cityscores[0].npisore &&
      this.state.cityscores[0].npisore != null
    ) {
      var getdata = {
        start: 0,
        limit: 10,
        order: latitude,
        orderBy: longitude,
        fields: [
          {
            name: "ROUND(AVG(npi),2)",
            value: this.state.cityscores[0].npisore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(personal),2)",
            value: this.state.cityscores[0].personalscore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(value),2)",
            value: this.state.cityscores[0].valuescore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(school),2)",
            value: this.state.cityscores[0].schoolscore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(crime),2)",
            value: this.state.cityscores[0].crimescore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(walkability),2)",
            value: this.state.cityscores[0].walkscore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(publicspaces),2)",
            value: this.state.cityscores[0].comscore.toFixed(2),
            operator: "=",
          },
          {
            name: "ROUND(AVG(curb),2)",
            value: this.state.cityscores[0].crubscore.toFixed(2),
            operator: "=",
          },
        ],
      };

      getsimilarcities(getdata)
        .then((result) => {
          this.setState({ similarcities: result.data.getSimilarCityList });
        })
        .catch((error) => {});
    }
  };
  checkSavedStatus = () => {
    if (this.state.userId && this.state.userId !== "") {
      const adddata = {
        userId: this.state.userId,
        name: this.city_name ? this.city_name : "",
      };
      checkSavedcitybyuserStatus(adddata)
        .then((result) => {
          let savedStatus = 0;
          if (
            result.data &&
            result.data.checkSavedcitybyuserStatus.length > 0
          ) {
            savedStatus = result.data.checkSavedcitybyuserStatus[0].savedStatus;
          }
          if (savedStatus === 1) {
            this.setState({
              save: true,
            });
          } else {
            this.setState({
              save: false,
            });
          }
        })
        .catch((error) => {
          console.log("error->", error);
        });
    }
  };

  cleanLocationName = (name) => {
    // Replace dashes with spaces
    const formattedName = name.replace(/-/g, " ");
    // Remove the last word
    return formattedName.split(" ").slice(0, -1).join(" ");
  };

  getcityReviews = (sortby) => {
    var cityname = this.city_name ? this.cleanLocationName(this.city_name) : "";
    var userId = localStorage.getItem("userId")
      ? localStorage.getItem("userId")
      : this.state.userId;

    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: sortby,
      fields: [{ name: "cityname", value: cityname, operator: "=" }],
      auth_userId: userId,
    };

    getAllcityreview(getdata)
      .then((result) => {
        this.setCityReview(result);
      })
      .catch((error) => {
        console.log("error-->", error);
      });
  };

  setCityReview = (result) => {
    let houseberrypick = [];
    let allreview = [];
    let pending = [];
    let houseberrytake = [];
    if (result.data.getcityreview.length > 0) {
      this.setState({
        Cityreviews: result.data.getcityreview,
      });
      houseberrypick = result.data.getcityreview.filter(
        (reviewdata) => reviewdata.editor_rate > "3",
      );
      allreview = result.data.getcityreview.filter(
        (reviewdata) => reviewdata.editor_rate > "0",
      );
      pending = result.data.getcityreview.filter(
        (reviewdata) => reviewdata.editor_rate == "0",
      );
      houseberrytake = result.data.getcityreview.filter(
        (reviewdata) => reviewdata.editor_rate == "10",
      );
      this.setState({ houseberrycount: houseberrypick.length });
      this.setState({ allcount: allreview.length });
      this.setState({ pendingcount: pending.length });
      this.setState({ houseberrytakereview: houseberrytake });
      if (houseberrytake && houseberrytake.length > 0) {
        if (houseberrytake[0].curbAppealRating != null) {
          this.setState({ valueclub: houseberrytake[0].curbAppealRating });
        }
        this.setState({
          valuequality: houseberrytake[0].publicSpacesRating,
        });
        this.setState({
          editreviewdata: houseberrytake[0].description,
        });
      }
      if (
        houseberrypick.length === 0 &&
        allreview.length === 0 &&
        pending.length === 0
      ) {
        this.setState({ is_display_review_txt: true });
      }
    } else {
      this.setState({ is_change_review_txt: false });
      this.setState({ is_display_review_txt: true });
    }
    this.setState({
      houseberrypickreview: houseberrypick,
    });
    this.setState({
      Cityreviews: allreview,
    });
    this.setState({
      pendingreview: pending,
    });
    this.setState({ houseberrytakereview: houseberrytake });
    this.setState({ houseberrycount: houseberrypick.length });
    this.setState({ allcount: allreview.length });
    this.setState({ pendingcount: pending.length });
    if (allreview.length > 0) {
      let keywords = allreview[0].keywords;
      if (keywords && keywords != "") {
        const splitValues = keywords.split(",");
        keywords = splitValues.join(", ");
        this.setState({ keyworddata: keywords });
        this.setState({ keywordfirst: splitValues[0] });
        this.setState({ keywordsec: splitValues[1] });
        this.setState({ keywordthird: splitValues[2] });
      }
    }
  };

  onReplySubmit = (e) => {
    let { reply } = this.state;

    var adddata = {
      questionId: e,
      userId: this.state.userId,
      cityName: this.city_name
        ? this.state.topneighborhood[0].postalcity_name
        : "",
      message: customencodeURIComponent(this.state.onreply[0]),
      postedDate: new Date(),
      updatedDate: new Date(),
    };

    addquestionandreplies(adddata)
      .then((result) => {
        if (result.data.createcity_question_answer.success === true) {
          let citylink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/City/" +
            this.state.cityFullName +
            "/";
          var subject = "A new Reply is Posted";
          var message = `A new Reply for a question is posted in your saved City <a target="_blank" href="${currenturl}">${
            this.state.topneighborhood[0].postalcity_name +
            ", " +
            this.state.state_name
          }</a>`;
          this.sendNotificationFunc(subject, message, e);
          setTimeout(() => {
            this.getquestionandanswers();
          }, 500);
          //this.getquestionandanswers();
        } else {
        }
      })
      .catch((error) => {
        console.error("graphql error--->", error);
      });
    this.setState({ onreply: "" });
    reply[e] = !reply[e];
    this.setState({ reply });
  };
  sendNotificationFunc = (subject, message) => {
    const noti_data = {
      subject: subject,
      message: message,
      userId: this.state.userdetails ? this.state.userdetails[1] : "",
      neighborhoodId: this.city_name
        ? this.state.topneighborhood[0].postalcity_name
        : "",
    };
    sendNotification(noti_data)
      .then((result) => {})
      .catch((error) => {});
  };

  askreply = (e, index) => {
    this.setState({
      values: { ...this.state.values, [index]: e.target.value },
    });

    this.setState({ [e.target.name]: [e.target.value] });
  };

  onComment = (index) => {
    const { loggedin } = this.state;
    if (loggedin) {
      let { comment } = this.state;
      comment[index] = !comment[index];
      this.setState({ comment });
    } else {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  onReply = (index, id) => {
    this.setState({ askque: false });
    Object.keys(this.state.reply).forEach((v) => (this.state.reply[v] = false));
    let { loggedin } = this.state;
    if (loggedin) {
      let { reply } = this.state;
      reply[id] = !reply[id];

      this.setState({ reply });
    } else {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };
  onSaveCity = (e) => {
    let { loggedin } = this.state;
    if (loggedin) {
      localStorage.removeItem("saveN");
      this.setState({ save: !this.state.save });
      this.savecity();
    } else {
      localStorage.setItem("saveN", "saveNeighbor");
      localStorage.setItem(
        "savecityid",
        this.state.topneighborhood[0].postalcity_name,
      );
      this.setState({ is_from_save: true });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  onShow = (index) => {
    let { data } = this.state;
    data[index] = !data[index];
    this.setState({ data });
  };

  togglePrev = (e, { value }, id) => {
    let condition1 = id.id === "neighborhoods";
    let condition2 = id.id === "agents";
    let condition3 = id.id === "sale";
    // activePage= value.activePage;
    condition1
      ? this.setState({ activePage: value.activePage })
      : condition2
        ? this.setState({ activePage1: value.activePage })
        : condition3
          ? this.setState({ activePage2: value.activePage })
          : null;
  };

  askQues = (e) => {
    this.setState({ [e.target.name]: [e.target.value] });
  };

  onQuestions = (e) => {
    this.setState({ ques: !this.state.ques });
  };

  modalSubmit = (values) => {
    let id = values.id;
    // this.setState({smodal:false,lmodal:false});

    if (id === "lmodal") {
      localStorage.setItem("auth_query", JSON.stringify(values));
      // Router.push({pathname: '/login',asPath: '/login', query: values},'/login');
      const username = values.email;
      const password = values.password;
      var flag = 1;
      if (values && values.email === "") {
        flag = 0;
        this.setState({
          email_err_status: true,
          email_err_msg: "Email is Required",
        });
      }
      if (values && values.password === "") {
        flag = 0;
        this.setState({
          pwd_err_status: true,
          pwd_err_msg: "Password is Required",
        });
      }
      if (flag === 1) {
        signIn({
          username,
          password,
        })
          .then(async (signInResult) => {
            if (signInResult.isSignedIn) {
              const user = await getCurrentUser();
              const session = await fetchAuthSession();
              const userAttributes = session.tokens?.idToken?.payload;
              const registertype = userAttributes
                ? [
                    userAttributes["custom:usertype"] || "",
                    userAttributes.name || "",
                    userAttributes.email_verified || false,
                  ]
                : [];
              if (userAttributes?.email_verified === true) {
                if (localStorage.saveR) {
                  this.setState({
                    smodal: false,
                    lmodal: false,
                  });
                  if (this.state.is_from_city_review) {
                    Router.push("/CityReview");
                    this.setState({ is_from_city_review: false });
                  } else {
                    window.location.reload();
                  }
                } else {
                  window.location.reload();
                }
              }
            }
          })
          .catch((err) => {
            if (err) {
              this.setState({
                message: err.message,
                loggedin: false,
                pwd_err_status: true,
                pwd_err_msg: err.message,
              });
            }
          });
      }
    } else if (id === "smodal") {
      localStorage.setItem("auth_query", JSON.stringify(values));
      //localStorage.setItem("previous_url", window.location.href);
      if (this.state.is_from_city_review) {
        localStorage.setItem("previous_url", "/CityReview");
      } else {
        localStorage.setItem("previous_url", window.location.href);
      }
      Router.push(
        { pathname: "/RegMain", asPath: "/RegMain", query: values },
        "/RegMain",
      );
    }
  };

  nextModal = (e) => {
    let id = e.target.id;
    id === "smodal"
      ? this.setState({ smodal: false, lmodal: true })
      : this.setState({ smodal: true, lmodal: false });
  };

  closeModal = () => {
    this.setState({ smodal: false, lmodal: false });
    this.setState({ is_from_city_review: false });
    localStorage.setItem("savecityid", "");
  };

  onLike = (index, e, data, queid, rlike_queid_qc_index, answerId, grid) => {
    let { loggedin } = this.state;
    if (loggedin) {
      let name = e.target.name;
      let { like, qlike, rlike } = this.state;
      if (name === "desc" && data.UserID != this.state.userId) {
        let cityreviewdata = this.state.Cityreviews;
        let resultdata = cityreviewdata.findIndex(({ id }) => id === data.id);
        if (cityreviewdata && cityreviewdata[resultdata]) {
          if (cityreviewdata[resultdata].helpStatus === 1) {
            cityreviewdata[resultdata].helpfulCount = data.helpfulCount - 1;
            cityreviewdata[resultdata].helpedUserId = "0";
            cityreviewdata[resultdata].helpStatus = 0;
            this.setState({
              Cityreviews: cityreviewdata,
            });
            this.forceUpdate();
          } else {
            cityreviewdata[resultdata].helpfulCount = data.helpfulCount + 1;
            cityreviewdata[resultdata].helpedUserId = "1";
            cityreviewdata[resultdata].helpStatus = 1;

            this.setState({
              Cityreviews: cityreviewdata,
            });
            this.forceUpdate();
          }
        }
        like[index] = !like[index];
        this.setState({ like });
        //var neighborhoodId = this.neighbor_id ? this.neighbor_id : "60e879f2-b1b0-4ce9-bb26-f06bb9631e98";
        var adddata = {
          reviewId: data.id,
          cityId: data.id,
          userId: this.state.userId,
          helpStatus: 1,
          helpedDate: new Date(),
          updatedDate: new Date(),
        };
        helpcityreview(adddata)
          .then((result) => {
            this.getcityReviews(this.state.sortby);
          })
          .catch((error) => {
            console.log("error", error);
          });
      } else if (name === "ques") {
        qlike[index] = !qlike[index];
        this.setState({ qlike });
      } else if (name === "rply") {
        var cityName = this.city_name
          ? this.state.topneighborhood[0].postalcity_name
          : "";
        var adddata = {
          questionId: queid,
          answerId: answerId,
          userId: this.state.userId,
          helpContent: 1,
          helpStatus: 1,
          cityName: cityName,
          helpedDate: new Date(),
          updatedDate: new Date(),
        };
        helpanswer(adddata)
          .then((result) => {
            this.getquestionandanswers();
          })
          .catch((error) => {});
        rlike[index] = !rlike[index];
        this.setState({
          ["rlike_" + queid + "_qc_" + index]:
            !this.state["rlike_" + queid + "_qc_" + index],
        });
        this.setState({ rlike }, () => {});
      } else {
        this.setState({ isratemodalopen: true });
      }
    } else {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
    setTimeout(() => this.getquestionandanswers(), 500);
  };

  getquestionandanswers = () => {
    var cityName = this.state.topneighborhood[0].postalcity_name;
    var auth_userId = localStorage.getItem("userId")
      ? localStorage.getItem("userId")
      : this.state.userId; //this.state.userId ? this.state.userId : localStorage.getItem('userId');
    var getdata = {
      start: 0,
      limit: 1000,
      order: "DESC",
      orderBy: "updatedDate",
      fields: [{ name: "cityName", value: cityName, operator: "=" }],
      //"auth_userId":auth_userId
    };
    getAllquestions(getdata)
      .then((result) => {
        this.setCityQuetions(result);
      })
      .catch((error) => {
        console.error("graphql error--->", error);
      });
  };
  setCityQuetions = (result) => {
    if (result.data.getcityquestions) {
      this.setState({
        questions: result.data.getcityquestions,
      });
      this.setState({
        //loading: false,
      });
    } else {
      console.log("error in submission");
    }
  };
  onGet = (e, name) => {
    let staticData = this.state;
    staticData.name = name;
    this.setState({ staticData });
  };

  onReview = (e) => {
    const { loggedin } = this.state;
    this.setState({ is_from_city_review: true });
    localStorage.setItem(
      "cityname",
      this.state.topneighborhood[0].postalcity_name,
    );
    localStorage.setItem(
      "statename",
      this.state.topneighborhood[0].label.split(",").pop(),
    );
    // if (loggedin) {
    localStorage.removeItem("saveR");
    Router.push("/CityReview").then(() => window.scrollTo(0, 0));
    if (!loggedin) {
      localStorage.setItem("previous_url", window.location.href);
    }
  };

  onReplies = (e, index) => {
    let { replies } = this.state;
    replies[index] = !replies[index];
    this.setState({ replies });
  };

  onSubmit = (e) => {
    let { loggedin } = this.state;
    if (loggedin) {
      //this.setState({ save: !this.state.save });
      this.setState({ askque: false });

      const adddata = {
        userId: this.state.userId,
        cityName: this.city_name
          ? this.state.topneighborhood[0].postalcity_name
          : "",
        question: customencodeURIComponent(this.state.onquestion[0]),
        postedDate: new Date(),
        updatedDate: new Date(),
        lastUpdated: new Date(),
      };
      addquestion(adddata)
        .then((result) => {
          if (result.data.createcityquestion.success === true) {
            let citylink =
              window.location.protocol +
              "//" +
              window.location.host +
              "/City/" +
              this.state.cityFullName +
              "/";
            var subject = "A new Question is Posted";
            var message = `a new Question was just asked in your saved city of <a target="_blank" href="${currenturl}">${
              this.state.topneighborhood[0].postalcity_name +
              ", " +
              this.state.topneighborhood[0].label.split(",").pop()
            }</a>`;
            this.sendNotificationFunc(subject, message, "");
            // setTimeout(() => {this.getquestionandanswers()},10000)
            this.getquestionandanswers();
          } else {
            console.log("error in submission");
          }
        })
        .catch((error) => {
          console.error("graphql error--->", error);
        });
      this.setState({ onquestion: "" });
    } else {
      const quesData = {
        userId: this.state.userId,
        question: customencodeURIComponent(this.state.onquestion[0]),
        cityName: this.state.topneighborhood[0].postalcity_name,
        label: this.state.topneighborhood[0].label,
      };
      localStorage.setItem("quesData", JSON.stringify(quesData));
      localStorage.setItem("previous_url", window.location.href);
      localStorage.setItem("isfromques", "Yes");
      document.getElementById("sign_up_btn").click();
    }
  };

  onRate = (index, e, grid, cityid) => {
    var adddata = {
      editor_rate: e.target.textContent,
      cityName: this.state.topneighborhood[0].postalcity_name,
      id: cityid,
    };

    editorrate(adddata)
      .then((result) => {
        this.getcityReviews(this.state.sortby);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  handlesortby = (e, data) => {
    this.setState({ sortby: data.value }, () =>
      this.getcityReviews(data.value),
    );
  };

  savecity = () => {
    const adddata = {
      userId: this.state.userId,
      name: this.state.cityFullName,
      savedDate: new Date(),
      updatedDate: new Date(),
      savedStatus: 1,
    };
    addsavedcitybyuser(adddata)
      .then((result) => {
        if (createsavedcitybyuser.message === "City removed successfully!") {
          this.setState({ save: false });
        } else {
          this.setState({ save: true });
        }
      })
      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };

  onReviews = (e) => {
    this.setState({ revs: !this.state.revs });
  };
  askquestion = () => {
    Object.keys(this.state.reply).forEach((v) => (this.state.reply[v] = false));
    this.setState({ askque: !this.state.askque });
  };

  modalhelpful = (e, imageid, image) => {
    this.setState({ loaderactive: true });
    var adddata = {
      reviewId: imageid,
      cityname: image.cityname,
      userId: this.state.userId,
      helpStatus: 1,
      helpedDate: new Date(),
      updatedDate: new Date(),
    };

    helpcityimagesreview(adddata)
      .then((result) => {
        this.setState({ is_slider: true });
        this.getcityimage();
        //this.getNhReviews(this.state.sortby);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  onImage = (e) => {
    const { loggedin } = this.state;
    if (loggedin) {
      localStorage.setItem(
        "statename",
        this.state.topneighborhood[0].label.split(",").pop(),
      );
      localStorage.setItem(
        "cityname",
        this.city_name ? this.state.topneighborhood[0].postalcity_name : "",
      );
      window.location.href = "/CityImages";
    } else {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  /* PERSONAL MODAL START */
  openpersonalmodal = () => {
    this.setState({ modalpersonalIsOpen: true });
  };
  closeModalpersonal() {
    this.setState({ modalpersonalIsOpen: false });
  }
  handlepriceminchange = (e, data) => {
    this.setState({ pricemin: data.value });
    this.setState({ selectedmin: data.value });
  };
  handlepricemaxchange = (e, data) => {
    this.setState({ pricemax: data.value });
    this.setState({ selectedmax: data.value });
  };
  schoolChangeHorizontal = (svalue) => {
    this.setState({
      schoolval: svalue,
    });
  };
  townChangeHorizontal = (tvalue) => {
    this.setState({
      townval: tvalue,
    });
  };

  crimeChangeHorizontal = (cvalue) => {
    this.setState({
      crimerateval: cvalue,
    });
  };

  walkabilityChangeHorizontal = (wvalue) => {
    this.setState({
      walkabilityval: wvalue,
    });
  };

  communityChangeHorizontal = (comvalue) => {
    this.setState({
      communityval: comvalue,
    });
  };

  curbappealChangeHorizontal = (curbvalue) => {
    this.setState({
      curbappealval: curbvalue,
    });
  };

  valueChangeHorizontal = (vvalue) => {
    this.setState({
      valueval: vvalue,
    });
  };
  onEditorreview = (e) => {
    const { loggedin } = this.state;
    this.setState({ is_from_city_review: true });
    localStorage.setItem(
      "cityname",
      this.state.topneighborhood[0].postalcity_name,
    );
    localStorage.setItem(
      "statename",
      this.state.topneighborhood[0].label.split(",").pop(),
    );
    if (loggedin) {
      localStorage.removeItem("saveR");
      Router.push({
        pathname: "/CityReview",
        query: { role: "editor" },
      }).then(() => window.scrollTo(0, 0));
    } else {
      localStorage.setItem("saveR", "saveReview");
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };
  handlegosubmitclick = () => {
    if (this.state.userId) {
      if (
        (this.state.initial_pre_data &&
          this.state.initial_pre_data.length > 0) ||
        this.state.is_from_add === true
      ) {
        const updatedata = {
          userId: this.state.userId,
          schoolScore: this.state.schoolval,
          crimeRate: this.state.crimerateval,
          walkability: this.state.walkabilityval,
          towncenter: this.state.townval,
          curbAppeal: this.state.curbappealval,
          publicspaces: this.state.communityval,
          valueIndex: this.state.valueval,
          pricemax: this.state.pricemax,
          pricemin: this.state.pricemin,
        };
        localStorage.setItem("personal_data", JSON.stringify(updatedata));
        updateNeighborSearch(updatedata)
          .then((result) => {})
          .catch((error) => {});
      } else {
        this.addpersonaldata();
      }

      localStorage.setItem("is_fill_personalize", true);
    }
    const adddata = {
      userId: this.state.userId,
      schoolScore: this.state.schoolval,
      crimeRate: this.state.crimerateval,
      walkability: this.state.walkabilityval,
      towncenter: this.state.townval,
      curbAppeal: this.state.curbappealval,
      publicspaces: this.state.communityval,
      valueIndex: this.state.valueval,
      pricemax: this.state.pricemax,
      pricemin: this.state.pricemin,
    };
    localStorage.setItem("personal_data", JSON.stringify(adddata));
    localStorage.setItem("is_fill_personalize", true);
    localStorage.setItem("is_already_perosnal", false);
    this.setState({ modalpersonalIsOpen: false });
    this.getcityscore();
  };

  addpersonaldata = () => {
    const adddata = {
      userId: this.state.userId,
      schoolScore: this.state.schoolval,
      crimeRate: this.state.crimerateval,
      walkability: this.state.walkabilityval,
      towncenter: this.state.townval,
      curbAppeal: this.state.curbappealval,
      publicspaces: this.state.communityval,
      valueIndex: this.state.valueval,
      pricemax: this.state.pricemax,
      pricemin: this.state.pricemin,
    };
    // localStorage.setItem("personal_data", JSON.stringify(adddata));
    addNeighbourSearch(adddata).then((result) => {
      this.setState({ is_from_add: true });
      if (result.data.createNeighbourSearch.success === true) {
        //this.setState({Insertmessage:result.data.createSchool.message})
      } else if (result.data.createNeighbourSearch.success === false) {
        const msg = result.data.createNeighbourSearch.message;

        //this.setState({Insertmessage:errmsg}) ;
      }
    });
  };

  handlesave = () => {
    if (this.state.userId === "") {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
      this.setState({ modalpersonalIsOpen: false });
      const adddata = {
        userId: this.state.userId,
        schoolScore: this.state.schoolval,
        crimeRate: this.state.crimerateval,
        walkability: this.state.walkabilityval,
        towncenter: this.state.townval,
        curbAppeal: this.state.curbappealval,
        publicspaces: this.state.communityval,
        valueIndex: this.state.valueval,
        pricemax: this.state.pricemax,
        pricemin: this.state.pricemin,
      };
      localStorage.setItem("personal_data", JSON.stringify(adddata));
      localStorage.setItem("is_from_save", "Y");
    } else {
      this.handlegosubmitclick();
      this.setState({ modalpersonalIsOpen: false });
    }
  };

  onEditreview = (e, data) => {
    this.openeditreviewmodal();
  };
  openeditreviewmodal = () => {
    this.setState({ modaleditreviewIsopen: true });
  };
  closeeditreviewmodal = () => {
    this.setState({ modaleditreviewIsopen: false });
  };

  onDeletereview = (e, data) => {
    const reviewData = [...this.state.houseberrytakereview];
    const reviewid = reviewData[0].id;
    deletecityreview(reviewid)
      .then((result) => {
        this.getcityReviews(this.state.sortby);
        this.getcitydata();
        // this.setState({ modaleditreviewIsopen: false });
      })
      .catch((error) => {
        this.getcityReviews(this.state.sortby);
        this.getcitydata();
      });
  };

  handleviewclick = () => {
    localStorage.setItem("ispagemain", true);
    const address = `${
      this.state.topneighborhood[0].postalcity_name
    },${this.state.topneighborhood[0].label.split(",").pop().trim()}, USA`;
    const url = `${window.location.protocol}//${window.location.host}/?address=${address}`;
    window.open(url, "_blank");
  };
  SubscribtionModalSubmit = (e) => {
    let emailregularExpression = new RegExp(
      "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$",
    );
    if (this.state.subscribeemail === "") {
      this.setState({
        subscribeemailstatus: true,
        subscribe_err_msg: "Please enter your email",
      });
    } else if (!emailregularExpression.test(this.state.subscribeemail)) {
      this.setState({
        subscribeemailstatus: true,
        subscribe_err_msg: "Please enter valid email!",
      });
    } else {
      this.setState({
        subscribeemailstatus: false,
        subscribe_err_msg: "",
        isLoading: true,
      });
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10);
      const dynamicUrl = window.location.href;
      const slug = this.getLastSegment(dynamicUrl);
      const addsubscriptionData = {
        email: this.state.subscribeemail,
        subscribe_for: this.state.clickedItem,
        date: formattedDate,
        neighborhoodid: this.city_name,
        neighborhoodfullname: slug,
      };
      createsubscription(addsubscriptionData)
        .then((result) => {
          if (!result.data.createsubscription.success) {
            this.setState({
              subscribeemailstatus: true,
              subscribe_err_msg: result.data.createsubscription.message,
              subscribe_success_msg: "",
              isLoading: false,
            });
          } else {
            this.setState({
              subscribe_success_msg: "Subscription added successfully",
              isLoading: false,
            });
            setTimeout(() => {
              this.setState({ subscribemodal: false, isLoading: false });
            }, 1000);
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          console.error(error);
        });
    }
  };
  /* PERSONAL MODAL WRAP */
  render() {
    let {
      reply,
      data,
      comment,
      save,
      activePage,
      activePage1,
      smodal,
      lmodal,
      activePage2,
      staticData,
      ques,
      like,
      replies,
      commentData,
      qlike,
      rlike,
      cityscores,
      revs,
      topneighborhood,
    } = this.state;
    const formatvalueclub = (valueclub) => valueclub;
    const formatvaluequality = (valuequality) => valuequality;
    let [fullcount, quatercount, halfcount, emptycount, quaterhalf] = [
      "",
      "",
      "",
      "",
    ];

    if (cityscores.length > 0) {
      if (cityscores[0].npisore) {
        let rank = parseFloat((cityscores[0].npisore / 100) * 5);
        [fullcount, quatercount, halfcount, emptycount, quaterhalf] =
          get_ranking(rank);
      }
    }

    const editorpanes = [
      // {
      //   menuItem: "Houseberry Picks " + "(" + this.state.houseberrycount + ")",
      //   render: () => (
      //     <Tab.Pane attached={false}>
      //       {" "}
      //       <Segmant>
      //         <Grid>
      //           <Grid.Column
      //             width={8}
      //             style={{
      //               paddingRight: 0,
      //               paddingTop: 10,
      //               paddingBottom: 0,
      //               paddingLeft: 0,
      //             }}
      //           >
      //             {/* <Title name="Neighborhood Reviews" size="medium" /> */}
      //           </Grid.Column>
      //           <Grid.Column
      //             width={8}
      //             style={{
      //               paddingRight: 0,
      //               paddingTop: 10,
      //               paddingBottom: 0,
      //               textAlign: "right",
      //             }}
      //           >
      //             <span>
      //               Sort By:{" "}
      //               <Dropdown
      //                 inline
      //                 options={sortbyoptions}
      //                 defaultValue={sortbyoptions[0].value}
      //                 onChange={this.handlesortby}
      //               />
      //             </span>
      //           </Grid.Column>
      //         </Grid>
      //       </Segmant>
      //       <NewDescription
      //         desData={this.state.houseberrypickreview}
      //         display={data}
      //         showMore={revs}
      //         show={this.onShow}
      //         visibility={comment}
      //         click={this.onReviews}
      //         toggle={this.onComment}
      //         change={this.askQues}
      //         like={like}
      //         onLike={this.onLike}
      //         review={this.onReview}
      //         showeditbutton={this.state.showeditbutton}
      //         onRate={this.onRate}
      //         is_display_review_txt={this.state.is_display_review_txt}
      //         is_change_review_txt={this.state.is_change_review_txt}
      //       />
      //     </Tab.Pane>
      //   ),
      // },
      {
        menuItem: "All " + "(" + this.state.allcount + ")",
        render: () => (
          <Tab.Pane attached={false}>
            {" "}
            <Segmant>
              <Grid>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    paddingLeft: 0,
                  }}
                >
                  {/* <Title name="Neighborhood Reviews" size="medium" /> */}
                </Grid.Column>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    textAlign: "right",
                  }}
                >
                  <span>
                    Sort By:{" "}
                    <Dropdown
                      inline
                      options={sortbyoptions}
                      defaultValue={sortbyoptions[0].value}
                      onChange={this.handlesortby}
                    />
                  </span>
                </Grid.Column>
              </Grid>
            </Segmant>
            <NewDescription
              desData={this.state.Cityreviews}
              display={data}
              showMore={revs}
              show={this.onShow}
              visibility={comment}
              click={this.onReviews}
              toggle={this.onComment}
              change={this.askQues}
              like={like}
              onLike={this.onLike}
              review={this.onReview}
              showeditbutton={this.state.showeditbutton}
              onRate={this.onRate}
              is_display_review_txt={this.state.is_display_review_txt}
              is_change_review_txt={this.state.is_change_review_txt}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Pending " + "(" + this.state.pendingcount + ")",
        render: () => (
          <Tab.Pane attached={false}>
            {" "}
            <Segmant>
              <Grid>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    paddingLeft: 0,
                  }}
                >
                  {/* <Title name="Neighborhood Reviews" size="medium" /> */}
                </Grid.Column>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    textAlign: "right",
                  }}
                >
                  <span>
                    Sort By:{" "}
                    <Dropdown
                      inline
                      options={sortbyoptions}
                      defaultValue={sortbyoptions[0].value}
                      onChange={this.handlesortby}
                    />
                  </span>
                </Grid.Column>
              </Grid>
            </Segmant>
            <NewDescription
              desData={this.state.pendingreview}
              display={data}
              showMore={revs}
              show={this.onShow}
              visibility={comment}
              click={this.onReviews}
              toggle={this.onComment}
              change={this.askQues}
              like={like}
              onLike={this.onLike}
              review={this.onReview}
              showeditbutton={true}
              onRate={this.onRate}
              is_display_review_txt={this.state.is_display_review_txt}
              is_change_review_txt={this.state.is_change_review_txt}
            />
          </Tab.Pane>
        ),
      },
    ];
    const panes = [
      // {
      //   menuItem: "Houseberry Picks " + "(" + this.state.houseberrycount + ")",
      //   render: () => (
      //     <Tab.Pane attached={false}>
      //       {" "}
      //       <Segmant>
      //         <Grid>
      //           <Grid.Column
      //             width={8}
      //             style={{
      //               paddingRight: 0,
      //               paddingTop: 10,
      //               paddingBottom: 0,
      //               paddingLeft: 0,
      //             }}
      //           >
      //             {/* <Title name="Neighborhood Reviews" size="medium" /> */}
      //           </Grid.Column>
      //           <Grid.Column
      //             width={8}
      //             style={{
      //               paddingRight: 0,
      //               paddingTop: 10,
      //               paddingBottom: 0,
      //               textAlign: "right",
      //             }}
      //           >
      //             <span>
      //               Sort By:{" "}
      //               <Dropdown
      //                 inline
      //                 options={sortbyoptions}
      //                 defaultValue={sortbyoptions[0].value}
      //                 onChange={this.handlesortby}
      //               />
      //             </span>
      //           </Grid.Column>
      //         </Grid>
      //       </Segmant>
      //       <NewDescription
      //         desData={this.state.houseberrypickreview}
      //         display={data}
      //         showMore={revs}
      //         show={this.onShow}
      //         visibility={comment}
      //         click={this.onReviews}
      //         toggle={this.onComment}
      //         change={this.askQues}
      //         like={like}
      //         onLike={this.onLike}
      //         review={this.onReview}
      //         showeditbutton={this.state.showeditbutton}
      //         onRate={this.onRate}
      //         is_display_review_txt={this.state.is_display_review_txt}
      //         is_change_review_txt={this.state.is_change_review_txt}
      //       />
      //     </Tab.Pane>
      //   ),
      // },
      {
        menuItem: "All " + "(" + this.state.allcount + ")",
        render: () => (
          <Tab.Pane attached={false}>
            {" "}
            <Segmant>
              <Grid>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    paddingLeft: 0,
                  }}
                >
                  {/* <Title name="Neighborhood Reviews" size="medium" /> */}
                </Grid.Column>
                <Grid.Column
                  width={8}
                  style={{
                    paddingRight: 0,
                    paddingTop: 10,
                    paddingBottom: 0,
                    textAlign: "right",
                  }}
                >
                  <span>
                    Sort By:{" "}
                    <Dropdown
                      inline
                      options={sortbyoptions}
                      defaultValue={sortbyoptions[0].value}
                      onChange={this.handlesortby}
                    />
                  </span>
                </Grid.Column>
              </Grid>
            </Segmant>
            <NewDescription
              desData={this.state.Cityreviews}
              display={data}
              showMore={revs}
              show={this.onShow}
              visibility={comment}
              click={this.onReviews}
              toggle={this.onComment}
              change={this.askQues}
              like={like}
              onLike={this.onLike}
              review={this.onReview}
              showeditbutton={this.state.showeditbutton}
              onRate={this.onRate}
              is_display_review_txt={this.state.is_display_review_txt}
              is_change_review_txt={this.state.is_change_review_txt}
            />
          </Tab.Pane>
        ),
      },
    ];
    const review_ques_panes = [
      {
        menuItem: "Houseberry's Take",
        render: () => (
          <Tab.Pane attached={false}>
            <EditorDescription
              desData={this.state.houseberrytakereview}
              isEditor={this.state.is_editor}
              review={this.onEditorreview}
              userId={this.state.userId}
              onEditreview={this.onEditreview}
              onDeletereview={this.onDeletereview}
              isnh={false}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Reviews " + "(" + this.state.allcount + ")",
        render: () => (
          <div
            className={`review_sec_tab city_review_tab ${
              this.state.showeditbutton ? "editor_sec" : "all_sec_review"
            }`}
          >
            <Tab
              menu={{ text: true }}
              panes={this.state.showeditbutton ? editorpanes : panes}
              defaultActiveIndex={0}
            />
          </div>
        ),
      },
      {
        menuItem: "Questions " + "(" + this.state.questions.length + ")",
        render: () => (
          <Tab.Pane attached={false}>
            <div className="city_review_sec">
              <CommentList
                name="onreply"
                commentData={this.state.questions}
                visibility={reply}
                toggle={this.onReply}
                display={ques}
                click={this.onQuestions}
                change={this.askQues}
                show={replies}
                replies={this.onReplies}
                queslike={qlike}
                rplylike={rlike}
                onLike={this.onLike}
                changeval={this.askreply}
                // submit={this.onSubmit}
                submit={(e) => this.onReplySubmit(e)}
                value={this.state.values}
                totstate={this.state}
                askques={this.askquestion}
              />
              <Segmant>
                {/* <ButtonItem
                      size="small"
                      color="#c02e26"
                      icon
                      labelPosition="right"
                      onClick={() => this.askquestion()}
                    >
                      Ask a Question
                    </ButtonItem> */}
                {this.state.askque ? (
                  <div className="question_section">
                    <NewWcomment
                      name="onquestion"
                      form="question"
                      visibility={true}
                      changeval={this.askQues}
                      submit={this.onSubmit}
                      value={this.state.onquestion}
                      buttonName="Ask"
                      placeholder="Ask a Question ..."
                      userimage={
                        this.state.user_info
                          ? this.state.user_info[0].userimage
                          : ""
                      }
                      askques={this.askquestion}
                    />
                  </div>
                ) : null}
              </Segmant>
            </div>
          </Tab.Pane>
        ),
      },
    ];

    return (
      <>
        <div className="home-wrapper">
          <CitySEO
            topNeighborhood={topneighborhood}
            loading={this.state.loading}
          />
          <Layout search={true}>
            {!this.state.loading && (
              <div className={this.state.isMobile && "m-detailsCity-page"}>
                <Grid
                  stackable
                  style={{ maxWidth: "1280px", margin: "0 auto" }}
                  className="detailcity_top"
                >
                  <Grid.Row
                    style={
                      this.state.isMobile
                        ? { paddingTop: 0 }
                        : { paddingTop: 5 }
                    }
                  >
                    <Grid.Column
                      width={10}
                      computer={10}
                      tablet={16}
                      mobile={16}
                      className="full-width"
                    >
                      <div className="responsive-border">
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={this.state.isMobile ? 16 : 16}>
                              <div style={{ minHeight: 120 }}>
                                <Segmant>
                                  <div className="city_title">
                                    <span>City</span>
                                    <Grid>
                                      <Grid.Column
                                        width={this.state.isMobile ? 12 : 11}
                                        style={{
                                          paddingTop: 15,
                                        }}
                                        className="city_top_column"
                                      >
                                        <CityTitle
                                          isMobile={this.state.isMobile}
                                          topNeighborhood={
                                            this.state.topneighborhood
                                          }
                                          stateName={this.state.state_name}
                                        />
                                        {cityscores.length > 0 && (
                                          <>
                                            <div className="responsive-score">
                                              <div className="rating_section">
                                                <div className="rating_section">
                                                  <RatingStars
                                                    fullcount={fullcount}
                                                    quatercount={quatercount}
                                                    halfcount={halfcount}
                                                    quaterhalf={quaterhalf}
                                                    emptycount={emptycount}
                                                    score={Number(
                                                      (
                                                        (cityscores[0].npisore /
                                                          100) *
                                                        5
                                                      ).toFixed(2),
                                                    ).toFixed(1)}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="npi_rating">
                                              <a
                                                href={`/Cityranking/best-overall/${this.state.county_name.replace(
                                                  /\s+/g,
                                                  "-",
                                                )}`}
                                                target="_blank"
                                              >
                                                Ranked #{this.state.cityrank} in{" "}
                                                {this.state.county_name} County
                                              </a>
                                            </div>
                                          </>
                                        )}
                                      </Grid.Column>
                                      <Grid.Column
                                        className="save_share_container"
                                        width={5}
                                        style={{
                                          paddingTop: "0px",
                                        }}
                                      >
                                        <SaveCityButton
                                          loggedIn={this.state.loggedin}
                                          save={save}
                                          isMobile={this.state.isMobile}
                                          onSaveCity={this.onSaveCity}
                                        />

                                        <FollowCityPopup
                                          loggedIn={this.state.loggedin}
                                          isMobile={this.state.isMobile}
                                          onSubscribeClick={
                                            this.onSubscribebtnClick
                                          }
                                        />
                                        <div className="share-button-container">
                                          <ShareButton
                                            isMobile={this.state.isMobile}
                                            handleShareButtonClick={
                                              this.handleShareButtonClick
                                            }
                                          />
                                          <ShareModal
                                            isShareModalOpen={
                                              this.state.isShareModalOpen
                                            }
                                            handleCloseShareModal={
                                              this.handleCloseShareModal
                                            }
                                          />
                                        </div>
                                      </Grid.Column>
                                    </Grid>
                                  </div>
                                </Segmant>
                              </div>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        <div className="factor_section">
                          <NeighborhoodFactorsSection
                            factors={this.state.factors}
                            factors_right={this.state.factors_right}
                            isMobile={this.state.isMobile}
                            amenitiesFlag={this.state.amenitiesFlag}
                            medianPriceDomCityFlag={
                              this.state.medianPriceDomCityFlag
                            }
                            appreciationCityFlag={
                              this.state.appreciationCityFlag
                            }
                            handlescoreclick={this.handlescoreclick}
                          />
                        </div>
                        <Modal
                          isOpen={this.state.modalSlider}
                          onRequestClose={this.closeModalslider}
                          style={customStylesSlide}
                          contentLabel="Example Modal"
                          htmlOpenClassName={"detailnh_modal"}
                        >
                          <div className="slider_modal_btn">
                            <span
                              onClick={this.closeModalslider}
                              primary
                              style={{ marginTop: "10px" }}
                            >
                              X
                            </span>
                          </div>
                          <div className="slider_main_top">
                            <Grid className="modal_grid">
                              <GridRow>
                                <GridColumn
                                  mobile={16}
                                  tablet={16}
                                  computer={16}
                                >
                                  <CityGallery
                                    imageData={this.state.cityimages}
                                    openpopup={this.openpopup}
                                    selectedItem={this.state.selectedItem}
                                    user_id={this.state.userId}
                                    is_editor={this.state.is_editor}
                                    removephoto={this.removephoto}
                                    editphotocaption={this.editphotocaption}
                                    onRatemodal={this.onRatemodal}
                                    modalhelpful={this.modalhelpful}
                                    is_static={this.state.is_static}
                                    isloaderactive={this.state.loaderactive}
                                    ismodalopen={this.state.modalSlider}
                                    street={false}
                                    islistingmodalopen={
                                      this.state.islistingmodalopen
                                    }
                                  />
                                </GridColumn>
                              </GridRow>
                            </Grid>
                          </div>
                        </Modal>
                      </div>
                      <EditCaptionModal
                        editcaptionmodal={this.state.editcaptionmodal}
                        closeeditcaptionmodal={this.closeeditcaptionmodal}
                        customStyles={customStyles}
                        EditcaptionFormSubmit={this.EditcaptionFormSubmit}
                        selectedcaption={this.state.selectedcaption}
                      />
                      <div className="city_review_sec_divider">
                        <Divider
                          style={{
                            margin: "40px 0 0 0",
                            borderBottom: "1px solid #828282",
                          }}
                        />
                      </div>
                      <div className="city_review_sec">
                        <Segmant>
                          <div className="nh_review_title_top">
                            <div className="nh_title_main">
                              <Title
                                name="City Reviews & Questions"
                                size="medium"
                              />
                              <span>
                                {" "}
                                <img
                                  width="45px"
                                  src={
                                    process.env.NEXT_PUBLIC_CDN_ID +
                                    "static/images/nh_review_icon.png"
                                  }
                                  title="city review"
                                  alt="City Review"
                                />
                              </span>
                            </div>
                            <span>
                              <ButtonItem
                                as="div"
                                labelPosition="right"
                                floated="left"
                                onClick={
                                  this.state.is_editor
                                    ? this.onEditorreview
                                    : this.onReview
                                }
                                className="theme_blue btn_blue"
                              >
                                <ButtonItem
                                  //color="#1b57a5"
                                  icon="write"
                                  className="btn_blue_bg"
                                />
                                <Label
                                  as="a"
                                  name="saveNeighbor"
                                  content="Share Comments"
                                  basic
                                  //color="#1b57a5"
                                  pointing="left"
                                  className="theme_blue btn_blue"
                                />
                              </ButtonItem>
                            </span>
                          </div>
                          <div className="keywords_blk">
                            <Title
                              name="Key Words:"
                              size="small"
                              floated="left"
                              style={{ margin: "0 7px 7px 7px" }}
                            />
                            {this.state.keyworddata != "" ? (
                              <InText
                                name={
                                  this.state.keyworddata
                                    ? this.state.keyworddata
                                    : ""
                                }
                                size="small"
                                floated="left"
                                colorClass="black"
                              />
                            ) : (
                              <span className="first_review">
                                Be the first one to{" "}
                                <span
                                  onClick={this.onReview}
                                  className="first_review_write"
                                >
                                  write
                                </span>{" "}
                                city review
                              </span>
                            )}
                          </div>
                          <Tab
                            menu={{ text: true, attached: "bottom" }}
                            panes={review_ques_panes}
                            className="review_tab_inner"
                          />
                        </Segmant>
                      </div>
                      {this.state.isMobile && (
                        <>
                          <Segmant textAlign="left">
                            <div className="top_nh_title">
                              <Title
                                name={`Top Neighborhoods in`}
                                size="medium"
                                className="top_nh_txt_right"
                              />
                              <span className="top_nh_txt_lft">
                                <a
                                  href={`/Nhranking/best-overall/${this.state.cityFullName}`}
                                  target="_blank"
                                >
                                  {this.state.topneighborhood &&
                                  this.state.topneighborhood.length > 0 ? (
                                    <>
                                      {
                                        this.state.topneighborhood[0]
                                          .postalcity_name
                                      }
                                      , {this.state.state_name}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </span>
                            </div>
                            <NeighborhoodsList
                              id="neighborhoods"
                              itemData={
                                this.state.topneighborhood &&
                                this.state.topneighborhood.length > 0
                                  ? this.state.topneighborhood
                                  : []
                              }
                              prev={this.togglePrev}
                              active={activePage}
                              href="/Neighborhood/"
                              customclass="sim_nei_imgs"
                              ispage="detailcity"
                              isEnabled={true}
                              seeFullListLink={`/Nhranking/best-overall/${formattedCityName(
                                this.state.topneighborhood &&
                                  this.state.topneighborhood.length > 0 &&
                                  this.state.topneighborhood[0].postalcity_name,
                              )}-${this.state.state_name.trim()}`}
                            />
                          </Segmant>
                        </>
                      )}
                      {this.state.isMobile && (
                        <Segmant textAlign="left" className="city_photos">
                          <Title name="City Photos" size="medium" />
                          <div
                            className="add_photos"
                            style={{ display: "inherit", width: "auto" }}
                          >
                            <ButtonItem
                              as="div"
                              labelPosition="right"
                              floated="right"
                              onClick={this.onImage}
                              className="theme_blue btn_blue"
                            >
                              <ButtonItem
                                icon="camera retro"
                                className="btn_blue_bg"
                              />
                              <Label
                                as="a"
                                name="saveNeighbor"
                                content="Add Photos"
                                basic
                                pointing="left"
                                onClick={this.onImage}
                                className="theme_blue btn_blue"
                              />
                            </ButtonItem>
                          </div>
                        </Segmant>
                      )}
                      {this.state.isMobile &&
                        this.state.cityimages &&
                        this.state.cityimages.length > 0 && (
                          <div className="nh_gallery_sec">
                            <NhGallery
                              imageData={this.state.cityimages}
                              openpopup={this.openpopup}
                              page="city"
                            />
                          </div>
                        )}
                      <Segment basic id="school_serve">
                        <SchoolsSection
                          schoollisting={this.schoollisting}
                          schoolloader={this.state.schoolloader}
                          schoolloadertxt={this.state.schoolloadertxt}
                          isMobile={this.state.isMobile}
                          shead={shead}
                          page="city"
                        />
                      </Segment>

                      <Segment
                        basic
                        style={{ paddingBottom: "0px", marginBottom: "0px" }}
                        className="amenities_segment"
                        id="amenities_nh"
                      >
                        <Divider />
                        <div
                          className="responsive-border"
                          style={{ padding: "5px" }}
                        >
                          <Title name="City Amenities" size="medium" />
                          <div className="amenities_sec">
                            <AmenitiesItem
                              className="amenities_scores"
                              amenitiesgrid={this.state.amenities_factor}
                            />
                          </div>

                          <div className="overall_amenities">
                            <p>
                              Overall Amenities score:{" "}
                              {this.state.amenitiesscore}{" "}
                              {this.state.amenitiesFlag && <sup>(1)</sup>}
                            </p>
                            {this.state.amenitiesFlag && (
                              <span>(1)Incomplete Data</span>
                            )}
                          </div>
                        </div>
                      </Segment>
                      {this.state.topneighborhood &&
                        this.state.topneighborhood.length > 0 &&
                        this.state.topneighborhood[0].cityMonthlyMedianPrice &&
                        this.state.topneighborhood[0].cityMonthlyMedianPrice !==
                          "" && (
                          <>
                            <Segmant>
                              <Divider />
                              <div
                                className="responsive-border"
                                style={{ padding: "5px" }}
                              >
                                <Title
                                  name="Median Price Graph"
                                  size="medium"
                                />

                                <VictoryMap
                                  medianPrice={
                                    this.state.topneighborhood[0]
                                      .cityMonthlyMedianPrice
                                  }
                                  lastMonth={
                                    this.state.topneighborhood[0]
                                      .cityMedianPriceLastMonth
                                  }
                                />
                              </div>
                            </Segmant>
                          </>
                        )}
                    </Grid.Column>
                    <Grid.Column
                      width={6}
                      className="neighborphotosec no-box-shadow full-width"
                      computer={6}
                      tablet={16}
                      mobile={16}
                    >
                      {!this.state.isMobile && (
                        <Segmant textAlign="left" className="city_photos">
                          <Title name="City Photos" size="medium" />
                          <div
                            className="add_photos"
                            style={{ display: "inherit", width: "auto" }}
                          >
                            <ButtonItem
                              as="div"
                              labelPosition="right"
                              floated="right"
                              onClick={this.onImage}
                              className="theme_blue btn_blue"
                            >
                              <ButtonItem
                                icon="camera retro"
                                className="btn_blue_bg"
                              />
                              <Label
                                as="a"
                                name="saveNeighbor"
                                content="Add Photos"
                                basic
                                pointing="left"
                                onClick={this.onImage}
                                className="theme_blue btn_blue"
                              />
                            </ButtonItem>
                          </div>
                        </Segmant>
                      )}
                      {!this.state.isMobile &&
                        this.state.cityimages &&
                        this.state.cityimages.length > 0 && (
                          <div className="nh_gallery_sec">
                            <NhGallery
                              imageData={this.state.cityimages}
                              openpopup={this.openpopup}
                              page="city"
                            />
                          </div>
                        )}
                      {!this.state.isMobile && (
                        <>
                          <Segmant textAlign="left">
                            <div className="top_nh_title">
                              <Title
                                name={`Top Neighborhoods in`}
                                size="medium"
                                className="top_nh_txt_right"
                              />
                              <span className="top_nh_txt_lft">
                                <a
                                  href={`/Nhranking/best-overall/${this.state.cityFullName}`}
                                  target="_blank"
                                >
                                  {this.state.topneighborhood &&
                                  this.state.topneighborhood.length > 0 ? (
                                    <>
                                      {
                                        this.state.topneighborhood[0]
                                          .postalcity_name
                                      }
                                      , {this.state.state_name}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              </span>
                            </div>
                          </Segmant>
                          <NeighborhoodsList
                            id="neighborhoods"
                            itemData={
                              this.state.topneighborhood &&
                              this.state.topneighborhood.length > 0
                                ? this.state.topneighborhood
                                : []
                            }
                            prev={this.togglePrev}
                            active={activePage}
                            href="/Neighborhood/"
                            customclass="sim_nei_imgs"
                            ispage="detailcity"
                            isEnabled={true}
                            seeFullListLink={`/Nhranking/best-overall/${formattedCityName(
                              this.state.topneighborhood &&
                                this.state.topneighborhood.length > 0 &&
                                this.state.topneighborhood[0].postalcity_name,
                            )}-${this.state.state_name.trim()}`}
                          />
                        </>
                      )}
                      <Segmant className="expert_segment">
                        <div className="expert_contact_section">
                          <p>Looking to Buy or Sell?</p>
                          <Button primary fluid onClick={this.openAgentPopup}>
                            Contact a Neighborhood Expert
                          </Button>

                          <AgentContact
                            open={this.state.showAgentPopup}
                            onClose={this.closeAgentPopup}
                            neighborhoodname={
                              this.state.topneighborhood &&
                              this.state.topneighborhood.length > 0 &&
                              this.state.topneighborhood[0].postalcity_name
                            }
                          />
                        </div>
                      </Segmant>
                      <Segmant>
                        <Title name="City Map" size="medium" />
                        <div className="detailnh_map_right">
                          {this.state.lat !== "" && this.state.lng !== "" && (
                            <BottomMap
                              lat={this.state.lat}
                              lng={this.state.lng}
                              // ref={"map"}
                              cityname={
                                this.state.topneighborhood &&
                                this.state.topneighborhood.length > 0 &&
                                this.state.topneighborhood[0].postalcity_name
                              }
                              statename={
                                this.state.topneighborhood &&
                                this.state.topneighborhood.length > 0 &&
                                this.state.topneighborhood[0].label
                                  .split(",")
                                  .pop()
                              }
                              mapheight={250}
                            />
                          )}
                        </div>
                      </Segmant>
                      <p
                        onClick={() => this.handleviewclick()}
                        className="fullmapview"
                      >
                        View Full Map
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            )}
            <Modal
              isOpen={this.state.isratemodalopen}
              style={customStyles}
              contentLabel="Rate Modal"
            >
              <div
                className="close_icon_select close_personal close_perosnal_dnh"
                onClick={this.handlecloseisratemodal}
              >
                <a className="boxclose" id="boxclose"></a>
              </div>
              <p className="rate_err">You cannot rate your own review</p>
            </Modal>
            <EditReviewModal
              modaleditreviewIsopen={this.state.modaleditreviewIsopen}
              closeeditreviewmodal={this.closeeditreviewmodal}
              customStyles={customStyles}
              valueclub={this.state.valueclub}
              formatvalueclub={this.formatvalueclub}
              handleChangeclub={this.handleChangeclub}
              publicrate_err={this.state.publicrate_err}
              valuequality={this.state.valuequality}
              formatvaluequality={this.formatvaluequality}
              handleChangequality={this.handleChangequality}
              curbrate_err={this.state.curbrate_err}
              keywordfirst={this.state.keywordfirst}
              handlekeywordfirstChange={this.handlekeywordfirstChange}
              keywordsec={this.state.keywordsec}
              handlekeywordsecChange={this.handlekeywordsecChange}
              keywordthird={this.state.keywordthird}
              handlekeywordthirdChange={this.handlekeywordthirdChange}
              houseberrytakereview={this.state.houseberrytakereview}
              reviewChange={this.reviewChange}
              description_err_status={this.state.description_err_status}
              description_err_msg={this.state.description_err_msg}
              EditreviewFormSubmit={this.EditreviewFormSubmit}
              page="city"
            />
          </Layout>
          <Segment>
            <div className="mt-30">
              {!this.state.loading && <LandingFooter />}
            </div>
          </Segment>

          <FeedbackForm />
          <SuccessModal
            ismodalopen={this.state.ismodalopen}
            closeModalsucess={this.closeModalsucess}
            customStylesReview={customStylesReview}
          />
          <SubscribeModal
            subscribemodal={this.state.subscribemodal}
            closesubscribemodal={this.closesubscribemodal}
            customStyles={customStyles}
            SubscribtionModalSubmit={this.SubscribtionModalSubmit}
            subscribeemail={this.state.subscribeemail}
            handlesubscribeemailChange={this.handlesubscribeemailChange}
            subscribeemailstatus={this.state.subscribeemailstatus}
            subscribe_err_msg={this.state.subscribe_err_msg}
            subscribe_success_msg={this.state.subscribe_success_msg}
            isLoading={this.state.isLoading}
            page="city"
          />
        </div>
      </>
    );
  }
}

export default DetailsCity;
